import { http } from '@/utils/http';

interface PdfReaderConfig {
  title: string;
  subtitle?: string;
  prefacePdfUrl: string;
  catalogPdfUrl: string;
  contentPdfUrl: string;
}

// 活动api baseurl
const urlPrefix = '/vote/public/common/controller.php?';
const tableId = 436;

const getBaseInfo = (tableId: number) => {
  return http.get(`${urlPrefix}tableId=${tableId}&enews=base-info`);
};

const parseReaderConfig = (actUrl: string): PdfReaderConfig => {
  const parsedData = JSON.parse(actUrl || '{}');

  return {
    title: parsedData.title || '',
    subtitle: parsedData.subtitle || parsedData.title || '',
    prefacePdfUrl: parsedData.prefacePdfUrl || '',
    catalogPdfUrl: parsedData.catalogPdfUrl || '',
    contentPdfUrl: parsedData.contentPdfUrl || '',
  };
};

const getReaderConfig = async () => {
  const response = await getBaseInfo(tableId);
  const actUrl =
    response && response.data && response.data.actUrl
      ? response.data.actUrl
      : '';

  return {
    ...response,
    data: parseReaderConfig(actUrl),
  };
};

export { getBaseInfo, getReaderConfig };
